const SignatureSection = ({ data }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px' }}>
          Declaration By Candidate
        </td>
      </tr>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px' }}>
  {
    data.gender === 1 ? (
      <>
       {/* मैंने महाविद्यालय विवरण पुस्तिका में घोषणा करता। करती हूँ कि उपरोक्त समस्त विवरण मेरी जानकारी के अनुसार सत्य है। तथ्य असत्य पाये जाने पर अथवा जानबूझ कर द्विपाये जाने पर मेरा प्रवेश निरस्त कर दिये जाने पर मुझे कोई आपत्ति नहीं होगी। मैंने रैगिंग अधिनियम 2009 का पढ़ लिया है, और उसका अक्षरशः पालन करूंगा। करूंगी।

मैं यह श्री घोषणा करता। करती हूं कि मैंने इस संस्था के अतिरिक्त अप किसी मलया में प्रवेश नहीं लिया है।, */}


      </>
    ) : (
      <>
       मैंने महाविद्यालय विवरण पुस्तिका में घोषणा करता। करती हूँ कि उपरोक्त समस्त विवरण मेरी जानकारी के अनुसार सत्य है। तथ्य असत्य पाये जाने पर अथवा जानबूझ कर द्विपाये जाने पर मेरा प्रवेश निरस्त कर दिये जाने पर मुझे कोई आपत्ति नहीं होगी। मैंने रैगिंग अधिनियम 2009 का पढ़ लिया है, और उसका अक्षरशः पालन करूंगा। करूंगी।

मैं यह श्री घोषणा करता। करती हूं कि मैंने इस संस्था के अतिरिक्त अप किसी मलया में प्रवेश नहीं लिया है।,


      </>
    )
  }
</td>

      </tr>
      <tr>
        <td style={{ border: '1px solid black', borderCollapse: 'collapse', padding: '10px 20px', paddingTop: '30px' }}>

      
      <>
        मैं विश्वास दिलाता / दिलाती हूँ कि श्री / श्रीमती _________________ मेरे संरक्षण में रहेंगे / रहेंगी।
        वह अपना आचरण एवं व्यवहार उचित रखेंगे / रखेंगी। यदि वे महाविद्यालय के नियमों का उल्लंघन करता / करती हैं और उन्हें
        महाविद्यालय से निष्कासित किया जाता है, तो मुझे कोई आपत्ति नहीं होगी।<br /><br />
        <strong>नोट:</strong> प्रवेश के समय अभिभावक का छात्रा के साथ महाविद्यालय में उपस्थित होना अनिवार्य है।
      </>

</td>

      </tr>
    </tbody>
  </table>
);

export default SignatureSection;